import { BaseService } from "./baseService";
class RegionService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "region";
    }
}
export const regionService = new RegionService();
//# sourceMappingURL=regionService.js.map